import React from 'react';
import { webUsbSupported } from '../utils/webAdbTap';
import DeviceIdChips from './DeviceIdChips';
import { useWebUsbCapture, startCapture, stopCapture, isActive, getDeviceName } from '../utils/webUsbCapture';

// Homepage toolbar shortcut for the in-browser Android capture (WebUSB):
// one click opens the device picker, then a live pill shows what's flowing.
// Same shared session as the Device capture card on the Config page.
// Hidden where WebUSB can't work (Safari/Firefox/mobile); those browsers keep
// the terminal command in Connect Device.

const base = {
  padding: '6px 12px', fontSize: 12, fontWeight: 600, borderRadius: 6,
  cursor: 'pointer', whiteSpace: 'nowrap', border: '1px solid var(--line)',
};

export default function AndroidCaptureButton({ style }) {
  const s = useWebUsbCapture();
  if (!webUsbSupported()) return null;
  const active = isActive(s);

  if (!active) {
    return (
      <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
        {s.phase === 'error' && (
          <span title={s.detail} style={{ fontSize: 11, color: 'var(--error-text, #c62828)', maxWidth: 260, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
            ⚠ {s.detail}
          </span>
        )}
        <button
          style={{ ...base, background: 'var(--bg)', color: 'inherit', ...style }}
          onClick={() => startCapture(getDeviceName())}
          title="Plug in an Android phone with USB debugging on, then pick it in the browser prompt. Streams GAM ad requests from logcat into this dashboard (works for production builds that can't be MITM'd)."
        >
          📱 Capture Android (USB)
        </button>
      </span>
    );
  }

  const label = {
    selecting: 'Pick the phone…',
    authorizing: 'Tap Allow on the phone…',
    running: `${(s.device && s.device.name) || 'Android'} · ${(s.stats && s.stats.sent) || 0} sent`,
  }[s.phase];
  return (
    <span
      title={s.detail || (s.device ? `Capturing as "${s.device.deviceName}"` : '')}
      style={{ ...base, display: 'inline-flex', alignItems: 'center', gap: 8, cursor: 'default', background: 'var(--bg)' }}
    >
      <span style={{ width: 8, height: 8, borderRadius: '50%', background: s.phase === 'running' ? 'var(--ok, #2e7d32)' : 'var(--warn, #ed6c02)' }} />
      {label}
      <button
        onClick={stopCapture}
        style={{ border: 'none', background: 'none', color: 'var(--error-text, #c62828)', fontWeight: 700, fontSize: 12, cursor: 'pointer', padding: 0 }}
      >
        {s.phase === 'running' ? 'Stop' : 'Cancel'}
      </button>
      {s.phase === 'running' && <DeviceIdChips device={s.device} stats={s.stats} />}
    </span>
  );
}
